module.exports = __webpack_public_path__ + "static/media/add-enrollment-virtual.0c423033.png";